<template>
  <div class="main-body">
    <div class="header">执法记录仪</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">绑定设备</el-button>
        <div style="float:right">

          <el-input v-model="userName" placeholder="选择服务人员" disabled style="width: 250px;margin-right: 10px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-input size="mini" placeholder="请输入SN号" v-model="sn" clearable style="margin-right:10px;width:160px"></el-input>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"
                :data="tableData" :height="th" border style="width: 100%;">

        <el-table-column prop="userName" label="用户名" width="100" fixed></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150" :formatter="getPhoneStr"></el-table-column>
        <el-table-column prop="sn" label="序列号（SN）" width="120"></el-table-column>
        <el-table-column prop="yzm" label="验证码"></el-table-column>
        <el-table-column prop="tdh" label="通道号"></el-table-column>

        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">

            <el-button size="mini" type="text" @click="viewCamera(scope.$index, scope.row)">查看</el-button>

            <el-button type="text" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeServe="showModalGetElderly=false" v-on:setServe="setElderly"></Elderly>

    <ViewCameraH5 ref="myViewCameraH5" v-show="showCamera" v-on:closeCamera="showCamera=false"></ViewCameraH5>

  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import {hex_md5, hex_md5_with_china} from "@/common/Base64MD5";
import {getGovernmentCode} from "@/utils/auth";

import Add from "./AddDisable"
import Elderly from "./ServeDisable";

import ViewCameraH5 from "@/views/Device/Camera/Comm/ViewCameraH5";

export default {
  name: "Role",
  data() {
    return {

      showModalAdd:false,
      tableLoading:false,

      showModalGetElderly:false,
      showCamera:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      userCode: "",
      userName:'',
      sn: "",


    };
  },
  components: {Add,Elderly,ViewCameraH5},
  created() {

    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalAdd: function () {
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },

    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },

    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },


    viewCamera(index,row){
      this.$refs.myViewCameraH5.init(row.sn,row.tdh);
      this.showCamera =!this.showCamera;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true

      let data = {
        timeStr: timeStr,
        sign: '',
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        userCode: this.userCode,
        sn: this.sn,
        governmentCode:getGovernmentCode(),
      };
      data.sign = '';
      data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCameraPhilips/PageByGovCode",
        data:data,
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {


        let data = {
          timeStr: timeStr,
          sign: '',
          deviceCameraPhilipsCode: row.deviceCameraPhilipsCode,
        };
        data.sign = '';
        data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)

        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceCameraPhilips/Delete",
          data: data,
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });


      }).catch(() => {
        //this.$message({type: "info", message: "已取消解绑",});
      });
    },



  },
};
</script>

<style scoped>
</style>
